export const CUSTOMERS_RECEIVED_TURN_CUSTOMERS = 'customers.RECEIVED_TURN_CUSTOMERS';
export const CUSTOMERS_SET_UP_CUSTOMER_PHASE = 'customers.SET_UP_CUSTOMER_PHASE';
export const CUSTOMERS_PREPARE = 'customers.PREPARE';
export const CUSTOMERS_LOAD = 'customers.LOAD';
export const CUSTOMERS_RESET_VALID_VIEWING = 'customers.RESET_VALID_VIEWING';
export const CUSTOMERS_DISMISS = 'customers.DISMISS';
export const CUSTOMERS_SELL_TO_CUSTOMER = 'customers.SELL_TO_CUSTOMER';
export const CUSTOMERS_REQUEST_MORE = 'customers.REQUEST_MORE';
export const CUSTOMERS_PROVIDE_MORE = 'customers.PROVIDE_MORE';
export const CUSTOMERS_FINISH_TURN = 'customers.FINISH_TURN';
export const CUSTOMERS_RESET_SALES_FROM_VIEW_COUNT = 'customers.RESET_SALES_FROM_VIEW_COUNT';
export const CUSTOMERS_SHOW_EXTRA_CUSTOMERS_BUTTON = 'customers.SHOW_EXTRA_CUSTOMERS_BUTTON';
export const CUSTOMERS_SET_ANIMATED_VISIBLE_CUSTOMER_COUNT =
	'customers.SET_ANIMATED_VISIBLE_CUSTOMER_COUNT';
export const CUSTOMERS_ENABLE_NEGOTIATOR_FOR_VIEWING_CUSTOMERS =
	'customers.ENABLE_NEGOTIATOR_FOR_VIEWING_CUSTOMERS';
export const CUSTOMERS_UPDATE_VIEWING_CUSTOMERS = 'customers.UPDATE_VIEWING_CUSTOMERS';
export const CUSTOMERS_ENTRY_ANIMATION_COMPLETE =
	'customers.ENTRY_ANIMATION_COMPLETE';
export const CUSTOMERS_INCREMENT_ENTRY_ANIMATION_COMPLETE_COUNT =
	'customers.INCREMENT_ENTRY_ANIMATION_COMPLETE_COUNT';
export const CUSTOMERS_DECREMENT_PENDING_BARGAINING_COUNT =
	'customers.UPDATE_PENDING_BARGAINING_COUNT';
